import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLenis } from "@/hooks/useLenis";
import { api, LOGO_URL } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Founder from "@/components/Founder";
import Offerings from "@/components/Offerings";
import Courses from "@/components/Courses";
import LiveSessions from "@/components/LiveSessions";
import CTA from "@/components/CTA";
import Community from "@/components/Community";
import Footer from "@/components/Footer";
import EnquiryModal from "@/components/EnquiryModal";
import StickyBar from "@/components/StickyBar";

export default function Home() {
  useLenis();
  const [content, setContent] = useState(null);
  const [courses, setCourses] = useState([]);
  const [enquiry, setEnquiry] = useState({ open: false, course: null });

  useEffect(() => {
    Promise.all([api.get("/content"), api.get("/courses")])
      .then(([c, co]) => {
        setContent(c.data);
        setCourses(co.data);
      })
      .catch(() => setContent({}));
  }, []);

  return (
    <div className="bg-chalk min-h-screen">
      <AnimatePresence>
        {!content && (
          <motion.div
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
            className="fixed inset-0 z-[100] bg-navy flex items-center justify-center"
            data-testid="site-loader"
          >
            <motion.img
              src={LOGO_URL}
              alt="ScholarVerse LAB"
              className="h-20 w-20 rounded-full"
              animate={{ scale: [1, 1.08, 1] }}
              transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {content && (
        <>
          <Navbar content={content} />
          <Hero content={content} />
          <Marquee items={content.marquee_items || []} />
          <LiveSessions content={content} />
          <About content={content} />
          <Founder content={content} />
          <Offerings content={content} />
          <Courses courses={courses} content={content} onEnquire={(course) => setEnquiry({ open: true, course })} />
          <Community content={content} />
          <CTA content={content} />
          <Footer content={content} />
          <StickyBar content={content} />
          <EnquiryModal
            open={enquiry.open}
            course={enquiry.course}
            onClose={() => setEnquiry({ open: false, course: null })}
          />
        </>
      )}
    </div>
  );
}
